import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetView from "./FacetView";

var DisjunctiveFacet = /*#__PURE__*/function (_Component) {
  _inherits(DisjunctiveFacet, _Component);

  var _super = _createSuper(DisjunctiveFacet);

  function DisjunctiveFacet() {
    var _this;

    _classCallCheck(this, DisjunctiveFacet);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "itemFactory", function (args) {
      return _this.props.itemFactory(_objectSpread(_objectSpread({}, args), {}, {
        options: _objectSpread(_objectSpread({}, args.options), {}, {
          isChecked: args.options.selected
        })
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "isSelectedValue", function (facetProduct) {
      var filtersForThisFacet = _this.props.filters.get(_this.props.facet.get('key'));

      var facetProductsSelected = Immutable.Iterable.isIterable(filtersForThisFacet) ? filtersForThisFacet : Immutable.Set([filtersForThisFacet]);
      return facetProductsSelected.contains(facetProduct);
    });

    _defineProperty(_assertThisInitialized(_this), "createNewFilters", function (facetProduct) {
      return _this.props.filters.update(_this.props.facet.get('key'), function (fs) {
        return fs.includes(facetProduct) ? fs.delete(facetProduct) : fs.add(facetProduct);
      });
    });

    return _this;
  }

  _createClass(DisjunctiveFacet, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FacetView, {
        createNewFilters: this.createNewFilters,
        displayFreeCheckbox: this.props.displayFreeCheckbox,
        facet: this.props.facet,
        facetBar: this.props.facetBar,
        filters: this.props.filters,
        hiddenFilters: this.props.hiddenFilters,
        isSelectedValue: this.isSelectedValue,
        itemFactory: this.itemFactory,
        itemType: "checkbox",
        onFacetProductClick: this.props.onFacetProductClick,
        perspective: this.props.perspective,
        stateChangeRequested: this.props.stateChangeRequested,
        FacetComponent: this.props.FacetComponent
      });
    }
  }]);

  return DisjunctiveFacet;
}(Component);

_defineProperty(DisjunctiveFacet, "propTypes", {
  displayFreeCheckbox: PropTypes.bool,
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  facetBar: PropTypes.oneOf(['top', 'side']),
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  FacetComponent: PropTypes.func.isRequired
});

export { DisjunctiveFacet as default };